/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020-2022 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import {HierarchyListItemHandler} from "../handlers/HierarchyListItemHandler";
import { ActiveProjectSubMenuItemHandler } from "../handlers/ActiveProjectSubMenuItemHandler";

const NOT_FROM_BROWSER_ACTION = false;
const NO_NAV_HANDLER_CALLBACK = null;
const FOR_SUB_PAGE_BOOKMARK = true;
const NO_PROJECT_LOADED_CALLBACK = null;

export class ProjectContextService {

    constructor(navHandler, projectContainer) {
        this.navHandler = navHandler;
        this.projectContainer = projectContainer;
    }

    handleProjectSwitcherMenu() {
    fetch('../../ui/navContext/projectSwitcherList')
        .then((resp) => resp.json()) 
        .then(respData => {
            this._processProjectSwitcherPortals(respData);
        });
    }

    switchProjectForSubPageBookmark(subCatId, projectId, menuItemName) {
        this.switchProject(subCatId, projectId, menuItemName, NOT_FROM_BROWSER_ACTION, NO_NAV_HANDLER_CALLBACK, FOR_SUB_PAGE_BOOKMARK);
    }

    switchProject(subCatId, projectId, menuItemName, isFromBrowserAction, navHandleCallback, isForSubPageBookmark) {

        let isSwitchingFromCompanyLevel = !this.isCurrentProjectAtProjectLevelContext();

        fetch('../../ui/navContext/projectSwitch?subCatId='+subCatId+'&projectId='+projectId)
        .then((resp) => resp.json())
        .then(data => {

            //Hide landing page during switch project processing. This elimintes 
            // the affect of previous landing sticking when switching projects.
            if (isSwitchingFromCompanyLevel || (data.priorProjectId !== data.projectId)) {
                this._getCurrentProjectContainer().hideLandingPageAndSitemap();
            }
            this.handleProjectContextProperties(data.projectId, 
                data.projectName, 
                data.priorProjectId, 
                data.priorProjectName);

            //Show project side nav if not company project.
            this.handleShowProjectMenu(data.projectId, NO_PROJECT_LOADED_CALLBACK, menuItemName, isFromBrowserAction, isForSubPageBookmark);
                
            if (navHandleCallback) {
              navHandleCallback();
            }
        });
    }

    handleProjectContextProperties(projectId, projectName, priorProjectId, priorProjectName) {
        this._getCurrentProjectContainer().handleProjectState(projectId, 
            projectName, 
            priorProjectId, 
            priorProjectName,
            this.shouldShowRecentProject(projectId, priorProjectId));
    }

    handleShowProjectMenu(projectId, projectLoadedCallback, menuItemName, isFromBrowserAction, isForSubPageBookmark) {
        //Show project side nav if not company project.
        if (this._getCurrentProjectContainer().isProjectLevelContext(projectId)) {
           
          //Project Nav Items
          fetch('../../api/v1/navCollection/currentUser')
          .then((resp) => resp.json()) 
          .then(data => {
              
           //First reset all active menu ids
            this.resetAllActiveMenuItems();

            let projectNavItems = [];
            let navItems = data.navItems;
            this._getCurrentProjectContainer().projectContainerHierarchyListItemHandler = new HierarchyListItemHandler();
            this._getCurrentProjectContainer().projectContainerHierarchyListItemHandler.handleFromProjectSubMenu(projectNavItems, navItems, this._getCurrentProjectContainer());
            this._getCurrentProjectContainer().handleProjectMenuItemsState(projectNavItems);
            this._getCurrentProjectContainer().activeProjectSubMenuItemHandler = new ActiveProjectSubMenuItemHandler(this._getCurrentProjectContainer().projectContainerHierarchyListItemHandler);
            //Project menu item selection not needed if subpage bookmark.
            if (!isForSubPageBookmark) {
                this._getCurrentProjectContainer().selectProjectMenuItem(this._getCurrentProjectContainer().projectContainerHierarchyListItemHandler.getListItemIdByName(menuItemName), isFromBrowserAction);
            } else {
                //Handle active item from sub page bookmarks on project menu.
                let menuId = this._getCurrentProjectContainer().projectContainerHierarchyListItemHandler.getListItemIdByName(menuItemName);
                this._getCurrentProjectContainer().activeProjectSubMenuItemHandler.handle( this._getCurrentProjectContainer().projectContainerHierarchyListItemHandler.handleValidMenuItem(menuId).id);
            }

            //Handle project loaded callback.
            if (projectLoadedCallback !== NO_PROJECT_LOADED_CALLBACK) {
                projectLoadedCallback();
            }
          });  
        } else {
            //Handle project loaded callback.
            if (projectLoadedCallback !== NO_PROJECT_LOADED_CALLBACK) {
                projectLoadedCallback();
            }
        }
    }

    selectProjectMenuItem(id, isFromBrowserAction) {
        this._getCurrentProjectContainer().selectProjectMenuItem(id, isFromBrowserAction);
    }

    resetAllActiveMenuItems() {
        this.resetActiveSideNavMenuIds();
        this.resetActiveProjectSubMenuIds();
    }

    resetActiveSideNavMenuIds() {
        //Reset active side nav menu ids.
        this.navHandler.activeMenuItemHandler.resetCurrentActiveIds();
    }
    
    resetActiveProjectSubMenuIds() {
        //Reset active project sub menu ids.
        this._getCurrentProjectContainer().activeProjectSubMenuItemHandler.resetCurrentActiveIds();
    }

    _processProjectSwitcherPortals(respData) {
        this.navHandler.projectSwitcherPortals = Array.from(respData);
    }

    handleProjectRendering(portalName) {
        //If true, we show the project switcher component.
        if (this._isShowProjectSwitcher(portalName)) {
            this._showProjectTitleBar();
        } else {
            this._getCurrentProjectContainer().handleShowProjectTitleBarState(false);
        }
    }

    _isShowProjectSwitcher(portalName) {
    return this.navHandler.projectSwitcherPortals.includes(portalName);
    }

    _showProjectTitleBar() {
        this._getCurrentProjectContainer().handleShowProjectTitleBarState(true);
    }

    handleShowRecentProjectLink(currentProjectId, priorProjectId) {
        this._getCurrentProjectContainer().handleShowRecentProjectLinkState(this.shouldShowRecentProject(currentProjectId, priorProjectId));
    }

    shouldShowRecentProject(currentProjectId, priorProjectId) {
    //If prior project id is greater than 1, we should display the recent project link if we are default project
    return  !this._getCurrentProjectContainer().isProjectLevelContext(currentProjectId) &&
        this._getCurrentProjectContainer().isProjectLevelContext(priorProjectId);
    }

    isCurrentProjectAtProjectLevelContext() {
        return this._getCurrentProjectContainer().isCurrentProjectAtProjectLevelContext();
    }

    _getCurrentProjectContainer() {
        return this.projectContainer.current;
    }

    hideProjectRenderingForCompanyLevelMenuItem(menuItemName) {
        let menuItemId = this.navHandler.hierarchyListItemHandler.getListItemIdByName(menuItemName);
        let menuItem = this.navHandler.hierarchyListItemHandler.handleValidMenuItem(menuItemId);
        this.handleProjectRendering(menuItem.portalName);
    }
}